import { createMuiTheme } from '@material-ui/core/styles';
const defaultMuiTheme = createMuiTheme();
export default defaultMuiTheme;
//# sourceMappingURL=default.js.map